
function Accordion() {
    if (document.querySelector('.accordion') !== null) {
        this.init();
    }
}

Accordion.prototype.init = function ()
{
    var items = document.querySelectorAll('.faq');
    var that = this;

    Array.prototype.forEach.call(items, function (item) {
        item.addEventListener("click", function () {
            item.classList.toggle('clicked');
            jQuery(item).find('.faq__answer').slideToggle(200);
        });
    });
}




export default Accordion;


// WEBPACK FOOTER //
// ./js/components/accordion/index.js